import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { paths } from 'src/routes/routes/paths';

import { activeSnack } from './common';
import { del, get, put, post } from '../http';
import { covertToJSON } from '../../utils/stateToJson';

export const createMember = createAsyncThunk(
  'member/create',
  async ({ state, dispatch, navigate }) => {
    try {
      const URL = `/member/admin/new`;
      const response = await post(URL, state);
      if (response) {
        navigate(paths?.dashboard?.member_view(response?._id));
        dispatch(activeSnack({ type: 'success', message: 'Member created successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      console.log(error);
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getAllMembers = createAsyncThunk(
  'member/list',
  async ({ page, search, dispatch, limit, sort, date, referralMember }) => {
    try {
      const response = await get(
        `/member/admin/all?page=${page && page}&search=${search && search}&limit=${
          limit || 5
        }&sort=${sort || ''}&dateFrom=${date?.start_date || ''}&dateTo=${
          date?.end_date || ''
        }&referral_member=${referralMember || ''}`
      );
      console.log(response);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getAllReferralMembers = createAsyncThunk(
  'member/referral',
  async ({ page, search, dispatch }) => {
    try {
      const response = await get(
        `/member/admin/referral?page=${page && page}&search=${search && search}`
      );
      console.log(response);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getMemberClubIncomeTransactions = createAsyncThunk(
  'member/club-income-transactions',
  async ({
    page,
    search,
    dispatch,
    date,
    selectedClub,
    id,
    limit,
    transactionTypeValues,
    selectedMember,
    sort,
  }) => {
    console.log('dateValue =>', date);
    try {
      if (id) {
        const response = await get(
          // eslint-disable-next-line no-constant-condition
          `/club-income-transaction/admin/all?page=${page && page}&search=${
            search || ''
            // eslint-disable-next-line no-constant-condition
          }&dateFrom=${date ? date[0] : ''}&dateTo=${date ? date[1] : ''}&club=${
            selectedClub || ''
          }&member=${id || ''}`
        );
        return response;
      }
      const response = await get(
        // eslint-disable-next-line no-constant-condition
        `/club-income-transaction/admin/all?page=${page && page}&search=${
          search || ''
          // eslint-disable-next-line no-constant-condition
        }&dateFrom=${date ? date[0] : ''}&dateTo=${date ? date[1] : ''}&club=${
          selectedClub || ''
        }&limit=${limit || 25}&transaction_type=${transactionTypeValues || ''}&member=${
          selectedMember || ''
        }&sort=${sort || ''}`
      );
      return response;

      // return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      console.log('error =>', error);
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getMemberDetails = createAsyncThunk(
  'member/single',
  async ({ memberId, dispatch }) => {
    try {
      const response = await get(`/member/admin/${memberId}`);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const updateMemberDetails = createAsyncThunk(
  'member/update',
  async ({ state, dispatch, handleClose, handleClear, navigate }) => {
    try {
      const URL = `/member/admin/${state?.id}`;

      const response = await put(URL, state);
      if (response) {
        if (handleClose) {
          handleClose();
        }
        dispatch(activeSnack({ type: 'success', message: 'Member updated Successfully' }));
        return response;
      }

      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const updateMemberStatus = createAsyncThunk(
  'member/update/status',
  async ({ state, memberId, dispatch }) => {
    try {
      const URL = `/member/admin/status/${memberId}`;

      const response = await post(URL);
      if (response) {
        dispatch(activeSnack({ type: 'success', message: 'Member Status updated Successfully' }));
        return response;
      }

      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const deleteMember = createAsyncThunk(
  'member/delete',
  async ({ memberId, dispatch, handleCloseDeleteDialog, navigate, bool }) => {
    try {
      const response = await del(`/member/admin/${memberId}/`);
      if (response) {
        handleCloseDeleteDialog();
        if (bool === true) {
          navigate(-1);
        }
        dispatch(activeSnack({ type: 'success', message: 'Member deleted Successfully' }));
        return response?._id;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const memberPaymentUpload = createAsyncThunk(
  'member/payment',
  async ({ state, dispatch, enqueueSnackbar }) => {
    try {
      const URL = `member/payment`;
      const response = await post(URL, state);
      if (response) {
        dispatch(
          getMemberProfileDetails({
            dispatch,
          })
        );
        // dispatch(activeSnack({ type: 'success', message: response.message }));
        enqueueSnackbar(' Uploaded Successfully!');
        return response;
      }
      return false;
    } catch (error) {
      throw error?.response?.data?.message;
    }
  }
);

// member profile in case of register
export const getMemberProfileDetails = createAsyncThunk('member/me', async ({ dispatch }) => {
  try {
    const response = await get(`member/me`);
    console.log(response);
    if (response) {
      return response;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});
export const updateMemberPassword = createAsyncThunk(
  'password/update',
  async ({ state, enqueueSnackbar }) => {
    try {
      const response = await post(`password/update`, state);

      if (response) {
        enqueueSnackbar('Password Updated Successfully!');

        // navigate(paths?.auth?.login);

        return response;
      }
      return enqueueSnackbar('something went wrong', { variant: 'error' });
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      throw error?.response?.data?.message;
    }
  }
);
export const updateMemberProfileDetails = createAsyncThunk(
  'member/profile/update',
  async ({ state, enqueueSnackbar, dispatch }) => {
    try {
      const response = await post(`member/update`, state);

      if (response) {
        dispatch(
          getMemberProfileDetails({
            dispatch,
          })
        );
        enqueueSnackbar('Profile Updated Successfully!');

        // navigate(paths?.auth?.login);

        return response;
      }
      return enqueueSnackbar('something went wrong', { variant: 'error' });
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message, { variant: 'error' });
      throw error?.response?.data?.message;
    }
  }
);

export const memberSlice = createSlice({
  name: 'member',
  initialState: {
    loading: false,
    error: {},
    // staff
    members: {},
    referralMembers: {},
    clubIncomeTransactions: {},
    memberDetails: {},
    payment: {},
    memberProfileDetails: {},
    memberProfileUpdateDetails: {},
  },
  reducers: {
    clearStaffError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    [createMember.pending]: (state) => {
      state.loading = true;
    },
    [createMember.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.members;
      const newList = jsonState?.members;
      const modifiedList = {
        ...jsonState,
        members: Array.isArray(newList) ? [action.payload, ...newList] : [action.payload],
      };
      state.loading = false;
      state.members = modifiedList;
      state.error = {};
    },
    [createMember.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [getAllMembers.pending]: (state) => {
      state.loading = true;
    },
    [getAllMembers.fulfilled]: (state, action) => {
      state.loading = false;
      state.members = action.payload;
      state.error = {};
    },
    [getAllMembers.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [getAllReferralMembers.pending]: (state) => {
      state.loading = true;
    },
    [getAllReferralMembers.fulfilled]: (state, action) => {
      state.loading = false;
      state.referralMembers = action.payload;
      state.error = {};
    },
    [getAllReferralMembers.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [getMemberClubIncomeTransactions.pending]: (state) => {
      state.loading = true;
    },
    [getMemberClubIncomeTransactions.fulfilled]: (state, action) => {
      state.loading = false;
      state.clubIncomeTransactions = action.payload;
      state.error = {};
    },
    [getMemberClubIncomeTransactions.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [getMemberDetails.pending]: (state) => {
      state.loading = true;
    },
    [getMemberDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.memberDetails = action.payload;
      state.error = {};
    },
    [getMemberDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [updateMemberDetails.pending]: (state) => {
      state.loading = true;
    },
    [updateMemberDetails.fulfilled]: (state, action) => {
      console.log('action?.payload =>', action?.payload);
      const jsonState = covertToJSON(state)?.members;
      console.log('jsonState =>', jsonState?.members);
      const modifiedList = {
        ...jsonState,
        members: jsonState.members?.map((i) =>
          i._id === action?.payload?._id ? action?.payload : i
        ),
      };

      state.loading = false;
      state.members = modifiedList;
      state.error = {};
    },
    [updateMemberDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [updateMemberStatus.pending]: (state) => {
      state.loading = true;
    },
    [updateMemberStatus.fulfilled]: (state, action) => {
      console.log('action?.payload =>', action?.payload);
      const jsonState = covertToJSON(state)?.members;
      console.log('jsonState =>', jsonState?.members);
      const modifiedList = {
        ...jsonState,
        members: jsonState.members?.map((i) =>
          i._id === action?.payload?._id ? action?.payload : i
        ),
      };

      state.loading = false;
      state.members = modifiedList;
      state.error = {};
    },
    [updateMemberStatus.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [deleteMember.pending]: (state) => {
      state.loading = true;
    },
    [deleteMember.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.members;
      const modifiedList = {
        ...jsonState,
        members: jsonState.members?.filter((member) => member._id !== action.payload),
      };
      state.loading = false;
      state.members = modifiedList;
      state.error = {};
    },
    [deleteMember.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    //  member payment
    [memberPaymentUpload.pending]: (state) => {
      state.loading = true;
    },
    [memberPaymentUpload.fulfilled]: (state, action) => {
      state.loading = false;
      state.payment = action.payload;
      state.error = {};
    },
    [memberPaymentUpload.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // member profile
    [getMemberProfileDetails.pending]: (state) => {
      state.loading = true;
    },
    [getMemberProfileDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.memberProfileDetails = action.payload;
      state.error = {};
    },
    [getMemberProfileDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // member profile update
    [updateMemberProfileDetails.pending]: (state) => {
      state.loading = true;
    },
    [updateMemberProfileDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.memberProfileUpdateDetails = action.payload;
      state.memberProfileDetails = action.payload;
      state.error = {};
    },
    [updateMemberProfileDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearStaffError } = memberSlice.actions;

export default memberSlice.reducer;
